import { useTheme } from "@emotion/react";
import { Box, Link } from "@mui/material";
import { DynamicIcon } from "common/dynamicIcon";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { getServiceTypes } from "slices/services";

// `getServiceTypes` takes no key, so "the list is empty" was the only guard. That stays
// true when the request fails or genuinely returns nothing -- and because the rejected
// handler assigns a fresh array, the effect re-fired and retried in a loop, once per
// table cell. Ask at most once per page load instead.
let serviceTypesRequested = false;

const NiceService = (props) => {

  const theme = useTheme();
  const dispatch = useDispatch();

  const serviceTypes = useSelector((state) => state.services.serviceTypes )


  const wantedService = props?.wantedService;
  const implementorId = props?.implementorId;
  const objectId = props?.children;

  useEffect(() => {
    if (serviceTypesRequested || serviceTypes.length > 0) {
      return;
    }

    serviceTypesRequested = true;
    dispatch(getServiceTypes());
  }, [dispatch, serviceTypes]);


  if (wantedService) {
    //lookup the service
    const thisService = serviceTypes.find(
      (service) => service.serviceType === wantedService
    );

    

    let linkTo = thisService?.getUrl + objectId;

    // switch (wantedService){

    //   case "copilot":
    //     //get the name of the chat

    //   break:
    //   default:

    // }

    //thisService.name + " - " + objectId

    if (thisService) {
      return (
        <Box display={"flex"} flexDirection={"row"} gap={"1rem"}>
          {/* {cloneElement(thisService.icon, {
            sx: { color: theme.palette.primary.main },
          })} */}

<DynamicIcon iconName={thisService.icon} />

          <Link
            to={linkTo}
            component={RouterLink}
            underline="hover"
            fontSize="inherit"
          >
            {thisService.name + " - " + objectId}
          </Link>
        </Box>
      );
    } else {
      return objectId;
    }
  } else {
    return objectId;
  }
};

export default React.memo(NiceService);
